"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPLE_PROXY_ORG_ID_HEADER = void 0;
/**
 * X-AP-Context header containing the orgId required by Apple ASA API.
 */
exports.APPLE_PROXY_ORG_ID_HEADER = "x-ap-context";
